import { component, prop, action, getter } from '../../../decorators';

import { REMOVE_FROM_CART } from '../../../store/actions';

import Crud, { Nihilism } from '../../../api/crud';

import ComponentCreator from '../../../helpers/component.creator';

import { SOURCES_FOR_CLIP_MIXIN } from '../../../mixins/player.sources.mixin';

import Player from '../../../components/common/clip-player/clip-player.vue';
import VideoSummaryInfo from '../../../components/video-summary-info/video-summary-info.vue';
import SpinnerBtn from '../../../components/common/spinner-btn/spinner-btn.vue';

import l10n from '../../../transformers/l10n';

@component({
   components: { VideoSummaryInfo, Player, SpinnerBtn },
   mixins: [ SOURCES_FOR_CLIP_MIXIN ]
})
export default class CartRow {
   episode = null

   @prop({ type: Number, required: true }) idx
   @prop({ type: Object, required: true }) clip
   @prop({ type: Object, required: true }) cart

   @getter() getLoadedEpisod
   @getter('getCurrentShowId') showId

   /** @type {Function} */
   @action(REMOVE_FROM_CART) removeFromCart;

   get deleteTitle() {
      return l10n('cart.delete');
   }

   get downloadMXFTitle() {
      return l10n('cart.download_mxf');
   }

   get downloadSCCTitle() {
      return l10n('cart.download_scc');
   }

   async removeClip() {
      const { cart, clip } = this;

      const message = l10n('cart.confirm_remove_clip', { synopsis: clip.synopsis, name: cart.name });
      const res = await ComponentCreator.confirm(message);
      if (res) {
         await this.removeFromCart({ clipId: clip.id, cartId: cart.id, language: clip.language });
         this.$emit('clip-removed');
      }
   }

   async download() {
      const { clip } = this;
      const path = `/clfinder/shows/${this.showId}/clips/${this.clip.id}/url`;
      const api = new Crud(new Nihilism(path));
      const { url } = await api.load({ language: clip.language });
      window.location = url;
   }
}
